import React, { useState } from 'react';
import {
  CardListTitle,
  CardListTitleSubtitle,
  CardsListContainer,
  CardListAccordion,
  CardListAccordionSummary,
  CardListAccordionDetails,
  StyledUploadLink,
} from '../atoms/styles';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import { StudyCardList } from '../StudyCard/StudyCard';
import { Grid } from '@material-ui/core';
import { CardPreview } from '../card-preview/CardPreview';
import { useUser } from 'src/modules/shared';
import { AddEditDeleteCard, AddEditDeleteCardProps } from '../AddEditCard.tsx/AddEditCard';
import { StudyCardsTypes } from 'src/modules/shared/slices/study-card/api/studyCard';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

type CardsListProps = {
  title: string;
  subtitle: string;
  type: StudyCardsTypes;
  onOpenForm: () => void;
};

export const CardsList: React.FC<CardsListProps> = ({ title, subtitle, type, onOpenForm }) => {
  const { isAdmin, isSuperAdmin, isAuthor } = useUser();
  const viewMode = useAppSelector((state) => state.trajectories.viewMode);
  const [showPreviewCard, setShowPreviewCard] = useState<null | StudyCardsTypes>(null);
  const [showAddEditDeleteCardForm, setShowAddEditDeleteCardForm] = useState<
    null | AddEditDeleteCardProps['mode']
  >(null);

  const userCanEdit = (isAuthor || isSuperAdmin || isAdmin) && viewMode === 'edit';

  return (
    <>
      <CardsListContainer>
        <CardListAccordion defaultExpanded>
          <CardListAccordionSummary
            expandIcon={
              <FontAwesomeSpriteIcon
                icon={SpriteIconsSolid.CHEVRON_DOWN}
                color="secondary"
                iconSize="sm"
              />
            }
          >
            <span>
              <CardListTitle>{title}</CardListTitle>
              <CardListTitleSubtitle>{subtitle}</CardListTitleSubtitle>
            </span>
          </CardListAccordionSummary>
          <CardListAccordionDetails>
            {userCanEdit && (
              <div>
                <StyledUploadLink onClick={() => setShowAddEditDeleteCardForm('add')}>
                  + TOEVOEGEN
                </StyledUploadLink>
              </div>
            )}
            <Grid container spacing={1}>
              <StudyCardList type={type} onCardClick={setShowPreviewCard} />
            </Grid>
          </CardListAccordionDetails>
        </CardListAccordion>
      </CardsListContainer>

      {showPreviewCard && (
        <CardPreview
          type={showPreviewCard}
          onClose={() => setShowPreviewCard(null)}
          onOpenForm={onOpenForm}
          onEditCard={() => setShowAddEditDeleteCardForm('edit')}
        />
      )}

      {showAddEditDeleteCardForm && (
        <AddEditDeleteCard
          type={type}
          onClose={() => setShowAddEditDeleteCardForm(null)}
          mode={showAddEditDeleteCardForm}
        />
      )}
    </>
  );
};
